// Gilded Rails — Tier-B bundle (CLIENT only). Layers images over Tier-A. Generated by create-mod.
// NEVER import from Game.js / server.js / the sim / tests (pulls the keyArt PNG + globe lib).
import { gildedRailsData } from './bundle.data';
import { CHARACTERS } from './characters';
import keyArt from '../dominion/keyart.png';
import { getGlobe } from '../dominion/atlas/globe-lib';
import boardBg from './backgrounds/gilded-rails.png';

export const gildedRailsClient = Object.assign({}, gildedRailsData, {
  characters: CHARACTERS,
  portraits: {},
  keyArt: keyArt,
  atlasAssets: {},
  mapAssets: { 'gilded-rails': { boardBg: boardBg } },
  getGlobe: getGlobe,
});

export default gildedRailsClient;
